// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-flex-end"
      >
        <button
          class="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary"
          tabindex="0"
          type="button"
        >
          <span
            class="MuiButton-label"
          >
            Cancel
          </span>
          <span
            class="MuiTouchRipple-root"
          />
        </button>
        <div
          class="MuiBox-root MuiBox-root-1"
        >
          <button
            class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
            tabindex="0"
            type="button"
          >
            <span
              class="MuiButton-label"
            >
              Update
            </span>
            <span
              class="MuiTouchRipple-root"
            />
          </button>
          <div
            class="MuiCircularProgress-root hide MuiCircularProgress-colorPrimary MuiCircularProgress-indeterminate"
            role="progressbar"
            style="width: 24px; height: 24px; position: absolute; top: 50%; left: 50%; margin-top: -12px; margin-left: -12px;"
          >
            <svg
              class="MuiCircularProgress-svg"
              viewBox="22 22 44 44"
            >
              <circle
                class="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate"
                cx="44"
                cy="44"
                fill="none"
                r="20.2"
                stroke-width="3.6"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiGrid-root MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-xs-flex-end"
    >
      <button
        class="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary"
        tabindex="0"
        type="button"
      >
        <span
          class="MuiButton-label"
        >
          Cancel
        </span>
        <span
          class="MuiTouchRipple-root"
        />
      </button>
      <div
        class="MuiBox-root MuiBox-root-1"
      >
        <button
          class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
          tabindex="0"
          type="button"
        >
          <span
            class="MuiButton-label"
          >
            Update
          </span>
          <span
            class="MuiTouchRipple-root"
          />
        </button>
        <div
          class="MuiCircularProgress-root hide MuiCircularProgress-colorPrimary MuiCircularProgress-indeterminate"
          role="progressbar"
          style="width: 24px; height: 24px; position: absolute; top: 50%; left: 50%; margin-top: -12px; margin-left: -12px;"
        >
          <svg
            class="MuiCircularProgress-svg"
            viewBox="22 22 44 44"
          >
            <circle
              class="MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate"
              cx="44"
              cy="44"
              fill="none"
              r="20.2"
              stroke-width="3.6"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
